export default [
  {
    title: "Survey and Quiz",
    customIcon: "Survey",
    children: [
      {
        title: "Survey",
        route: "survey",
        path: "/survey/survey-list",
      },
      {
        title: "Quiz",
        route: "quiz",
        path: "/quiz/quiz-list",
      },
    ],
  },
];
